<template>
  <Container :headerWhite="2" :isShowContent="isShowContent">
    <div class="rules-body">
      <div class="item" v-for="(item, index) in newsSet" :key="index" :id="'a'+item.ID">
        <div class="date">{{formatDate(item.SeqTime)}}<span>|</span></div>
         <div class="slides">
              <div class="swiper-container" :class="'img-list'">
                   <div class="swiper-wrapper">
                         <div class="swiper-slide">
                              <ul>
                                  <li  v-for="(subItem, index) in item.NewsPhotoSet" :key="index"> 
                                    
                                    <img :data-src="$getImageUrl(subItem.Pic)" class="swiper-lazy"  v-if="false" >
                                    <div class="swiper-lazy-preloader swiper-lazy-preloader-white" v-if="false"></div>
                                    <img :src="$getImageUrl(subItem.Pic)" v-if="true">
                                      
                                  </li>
                              </ul>
                         </div>
                   </div>
              </div>
         </div>
       
        <div class="text">
          <h3 :class="'title-'+getLanguageName">{{getTitle(item)}}</h3>
          <p  v-html="getBaseContent(item)">

          </p>
       
        </div>
      </div>


    </div>
  </Container>
</template>

<script>

import Container from '@/components/Container.vue'

export default {
  name: "home",
  components: {Container},
  data() {
    return {
      
      isLoadingShow:true,
      model:{},
      newsSet:[],

      id:0,

      count:0,
      
      pageSize:5,
      pageIndex:1,


      isShow:false,
      isShowContent:true
  

    }
  },
  props: {},
  methods: {

    getData(){

      let id = this.id

      this.$request.get("/homepage",{params:{id:id}}).then((res)=>{
        if (res.data.code === 0) {
            this.model= res.data.data
            this.changeData()
        }

        this.isLoadingShow = false 
      })
    },

    changeData(){

      if(this.model){

        this.getNewsSet()
      
      }
    },

     getNewsSet(){

      this.count = this.model.count;

      if(this.count>0&& this.count>this.pageSize){
         this.pageIndex++;
      }

      //this.newsSet=[]
      //this.newsSet = this.model.NewsSet

      if(this.model.NewsSet){

        this.newsSet.push(...this.model.NewsSet);

      }


      if(this.newsSet){

        this.$nextTick(() => {
        
          if(this.id){
            this.$el.querySelector(`#a${this.id}`).scrollIntoView()    
        }

      })
       this.isShow = true
      }


    this.$nextTick(() => {

      setTimeout(() => {

         new Swiper('.img-list', {
          lazy: false,
          direction: 'horizontal',
          roundLengths: true,
          slidesPerView: 'auto',
          freeMode: true,
          scrollbar: {
            el: '.swiper-img',
            draggable:true,
            snapOnRelease: false,
        
          },
          mousewheel: false,
        });

        new Swiper('.sidebar-swiper', {
          direction: 'vertical',
          roundLengths: true,
          slidesPerView: 'auto',
          freeMode: true,
          scrollbar: {
            el: '.swiper-sidebar',
          },
          mousewheel: true,
        });
      }, 1000)


    });

    },   


    getTitle(info){
      let str = ''
      if(info){
       if(this.$store.state.language.name==='cn'){
          str = info.NewsTitle
        }else{

          str = info.NewsTitleEn
        }
      }
      return  this.$textareaFormatter(str)
    },


    getBaseContent(info){
      let str = ''
      if(info){
       if(this.$store.state.language.name==='cn'){
          str = info.BaseContent
        }else{

          str = info.BaseContentEn
        }
      }
      return this.$textareaFormatter(str)
    },    


    getContent(info){
      let str = ''
      if(info){
       if(this.$store.state.language.name==='cn'){
          str = info.NewsContent
        }else{

          str = info.NewsContentEn
        }
      }
      return this.$textareaFormatter(str)
    },


    formatDate(date){

      let str = ''
      if(date){
        let dt = new Date(date)
        let y = dt.getFullYear()
        let m = dt.getMonth() + 1
         m = m < 10 ? "0" + m : m

        return `${y}.${m}`

      }
      return str

    },

    

    navClick() {
      // 控制左边内容变化
    },

    menuSelect(id){


      if(id){
        this.$el.querySelector(`#a${id}`).scrollIntoView({ behavior: 'smooth' })    
      }

    },

  scroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件(距底部20px时触发加载)
      if (scrollTop + windowHeight >= scrollHeight - 5) {
        //触发更多函数  减一个常表示距离底部X个px
        setTimeout(() => {
          // 模拟请求数据

          const size =this.count - this.pageIndex * this.pageSize;

          if(size > 0){
            this.getData();
          
          }

         
        },500);
      }
    },    


    //函数防抖
    debounce(func, wait) {
                let timeout;
                return function () {
                    let context = this;
                    let args = arguments;
                    if (timeout) clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        func.apply(context, args)
                    }, wait);
                }
            },

           /*   //判断滚动方向
            handleScroll(e){
                let direction = e.deltaY > 0 ? 'down' : 'up'
                if(this.currentId<=1){
                    direction == 'down' ? this.currentId++ : this.currentId=1
                }else if(this.currentId>=this.listName.length){
                    direction == 'down' ? this.currentId= this.listName.length: this.currentId--
                }else{
                    direction == 'down' ? this.currentId++ : this.currentId--
                }

                this.scroll();
            }, */          

  },
  
  computed: {

  
    getLanguageName(){
        return this.$store.state.language.name
    },
 
   

  },

  created(){
  },
  mounted() {

    this.id = this.$route.params.id

    this.getData()
/* 
    this.$nextTick(() => {

      setTimeout(() => {

         new Swiper('.img-list', {
          lazy: false,
          direction: 'horizontal',
          roundLengths: true,
          slidesPerView: 'auto',
          freeMode: true,
          scrollbar: {
            el: '.swiper-img',
            draggable:true,
            snapOnRelease: false,
        
          },
          mousewheel: false,
        });

      }, 1000)


    }); */

    this.$nextTick(() => {

        window.addEventListener('mousewheel', this.debounce(this.scroll,300), true)||window.addEventListener("DOMMouseScroll",this.debounce(this.scroll,300),false)

    //  window.addEventListener('scroll', this.scroll, false);

    })

  },  

}
</script>